'use client';

import { ListStyleType, someList, toggleList } from '@platejs/list';
import { List, ListOrdered } from 'lucide-react';
import { useEditorRef, useEditorSelector } from 'platejs/react';

import { ToolbarButton } from '@/components/ui/toolbar';

export function FieldBulletedListToolbarButton({
  disabled,
}: {
  disabled?: boolean;
}) {
  const editor = useEditorRef();

  const pressed = useEditorSelector(
    (editor) => someList(editor, [ListStyleType.Disc]),
    []
  );

  return (
    <ToolbarButton
      pressed={pressed}
      tooltip="Bulleted list"
      disabled={disabled}
      onClick={() => {
        toggleList(editor, { listStyleType: ListStyleType.Disc });
      }}
    >
      <List className="size-4" />
    </ToolbarButton>
  );
}

export function FieldNumberedListToolbarButton({
  disabled,
}: {
  disabled?: boolean;
}) {
  const editor = useEditorRef();

  const pressed = useEditorSelector(
    (editor) => someList(editor, [ListStyleType.Decimal]),
    []
  );

  return (
    <ToolbarButton
      pressed={pressed}
      tooltip="Numbered list"
      disabled={disabled}
      onClick={() => {
        toggleList(editor, { listStyleType: ListStyleType.Decimal });
      }}
    >
      <ListOrdered className="size-4" />
    </ToolbarButton>
  );
}
